import Graylog from 'components/domain/analytics/Graylog/Graylog';
import { useActiveMember } from 'hooks';
import { useCallback, useMemo } from 'react';
import AnalyticsEvent from 'utils/constants/analytics/analyticsEvent';

function useSafetyOverviewAnalytics() {
  const member = useActiveMember();

  const recordOverviewClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_OVERVIEW,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordDetailsClickOnSafetyInspectionsCard = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_DETAILS_ON_INSPECTIONS_CARD,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordDetailsClickOnSafetyTrainingsCard = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_DETAILS_ON_TRAININGS_CARD,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordDetailsClickOnSafetyObservationsCard = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_DETAILS_ON_OBSERVATIONS_CARD,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordOpenIncidentsRibbonClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_OPEN_INCIDENTS,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordAwaitingReviewRibbonClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_AWAITING_REVIEW,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordReviewedIncidentsRibbonClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_REVIEWED_INCIDENTS,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordDetailsClickOnJSAReportsCard = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.safety.CLICK_DETAILS_ON_JSA_REVIEW_CARD,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  return useMemo(
    () => ({
      recordOverviewClick,
      recordDetailsClickOnSafetyInspectionsCard,
      recordDetailsClickOnSafetyTrainingsCard,
      recordDetailsClickOnSafetyObservationsCard,
      recordOpenIncidentsRibbonClick,
      recordAwaitingReviewRibbonClick,
      recordReviewedIncidentsRibbonClick,
      recordDetailsClickOnJSAReportsCard,
    }),
    [
      recordOverviewClick,
      recordDetailsClickOnSafetyInspectionsCard,
      recordDetailsClickOnSafetyTrainingsCard,
      recordDetailsClickOnSafetyObservationsCard,
      recordOpenIncidentsRibbonClick,
      recordAwaitingReviewRibbonClick,
      recordReviewedIncidentsRibbonClick,
      recordDetailsClickOnJSAReportsCard,
    ]
  );
}

export default useSafetyOverviewAnalytics;
